<template>
    <modal id="work-place-modal"
        size="large"
        v-model="showModal"
        :title="generateModalTitle('job')"
        @submit="submitData" :loading="loading"
        :preloader="preloader">

        <form
            ref="form"
            :data-url='selectedUrl ? selectedUrl : `${TENANT_BASE_URL}app/work-place`'
            @submit.prevent="submitData"
        >
            <app-form-group
                page="page"
                :label="$t('language')"
                type="select"
                v-model="locate"
                :list="languages"
            />
            <app-form-group
                page="page"
                :label="$t('title')"
                type="text"
                :placeholder="$placeholder('title', '')"
                v-model="formData.title[locate]"
                :error-message="$errorMessage(errors, 'title')"
                :required="true"
            />
            <app-form-group
                page="page"
                :label="$t('place')"
                type="text"
                :placeholder="$placeholder('place', '')"
                v-model="formData.place[locate]"
                :error-message="$errorMessage(errors, 'place')"
                :required="true"
            />
            <app-form-group
                page="page"
                :label="$t('station')"
                type="text"
                :placeholder="$placeholder('station', '')"
                v-model="formData.station[locate]"
                :error-message="$errorMessage(errors, 'station')"
                :required="true"
            />
            <app-form-group
                page="page"
                :label="$t('salary')"
                type="text"
                :placeholder="$placeholder('salary', '')"
                v-model="formData.salary[locate]"
                :error-message="$errorMessage(errors, 'salary')"
                :required="true"
            />
            <app-form-group
                page="page"
                :label="$t('deadline')"
                type="date"
                v-model="formData.deadline"
                :placeholder="$placeholder('deadline')"
                :error-message="$errorMessage(errors, 'deadline')"
            />
            <app-form-group
                page="page"
                :label="$t('status')"
                type="select"
                v-model="formData.status"
                :list="statusOptions"
                :placeholder="$placeholder('status')"
                :error-message="$errorMessage(errors, 'status')"
            />

            <app-form-group
                page="page"
                :label="$t('require_shift')"
                type="radio"
                v-model="formData.require_shift"
                :list="[
                    {id: 0, value: $t('no')},
                    {id: 1, value: $t('yes')},
                ]"
                :error-message="$errorMessage(errors, 'require_shift')"
            />

            <app-form-group
                page="page"
                :label="$t('display')"
                type="select"
                v-model="formData.permission"
                :error-message="$errorMessage(errors, 'permission')"
                :list="[
                    {id:0, value: $t('private')},
                    {id:1, value: $t('public')},
                ]"
            />

            <div class="form-group">
                <label>{{ $t('job_description') }}</label>
                <app-input
                    id="text-editor-for-content"
                    type="text-editor"
                    v-model="formData.content[locate]" row="4"
                    :placeholder="$textAreaPlaceHolder('job_description')"
                    :error-message="$errorMessage(errors, 'content')"
                />
            </div>
            <app-form-group
                type="textarea"
                label-alignment="top"
                :label="$t('remark')"
                :placeholder="$textAreaPlaceHolder('remark')"
                v-model="formData.remark[locate]"
                :error-message="$errorMessage(errors, 'remark')">
            </app-form-group>

            <div class="form-group">
                <label>{{ $t('attachments') }}</label>
                <app-input
                    type="dropzone"
                    v-model="files"
                    :error-message="$errorMessage(errors, 'file')"
                    :max-files="1"
                />
                <small class="text-muted font-italic mt-3 d-inline-block">
                    {{ $t('document_recommendation') }}
                </small>
            </div>

            <div class="form-group" v-if="current_files.length">
                <label>{{ $t('current_files') }}</label>
                <div class="img-container">
                    <div class="img-box" v-for="(url, index) in current_files" :key="'current-image-' + index">
                        <img v-if="isImage(url)"
                            :src="url"
                            class="img-thumbnail"
                            :title="getFileName(url)"
                        />
                        <div v-else
                            :href="url"
                            target="_blank"
                            class="d-flex align-items-center justify-content-center text-truncate img-thumbnail"
                            :title="getFileName(url)"
                        >
                            <i :class="`fa fa-file-${getFileExtension(url).substring(1)}`"></i>
                        </div>
                        <div class="img-action">
                            <button type="button"
                                class="btn btn-sm btn-primary"
                                @click="viewFile(url)"
                                :title="$t('view')">
                                <i class="fas fa-eye"></i>
                            </button>
                            <button type="button"
                                class="btn btn-sm btn-danger"
                                @click="deleteFile(index)"
                                :title="$t('delete')">
                                <i class="fas fa-trash"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="custom-field" v-if="displayFields.length > 0">
                <template v-for="field in displayFields">
                    <app-form-group
                        :key="field.id"
                        page="page"
                        :label="getFieldLabel(field)"
                        :type="field.type"
                        :list="field.options"
                        :error-message="$errorMessage(errors, field.name)"
                        :file-label="$placeholder('attachment', '')"
                        v-model="formData[field.name][locate]"
                    />
                </template>
            </div>

            <app-form-group-selectable
                type="multi-select"
                :label="$t('tags')"
                list-value-field="title"
                v-model="formData.tags"
                :chooseLabel="$t('tag')"
                :error-message="$errorMessage(errors, 'tags')"
                :fetch-url="`${TENANT_BASE_URL}app/interview-tag?per_page=0&type=0,1`"
            />
        </form>
    </modal>
</template>

<script>
import FormHelperMixins from "../../../../../common/Mixin/Global/FormHelperMixins";
import ModalMixin from "../../../../../common/Mixin/Global/ModalMixin";
import {TENANT_BASE_URL} from "../../../../../common/Config/UrlHelper";
import {addSelectInSelectArray, formDataAssigner} from "../../../../../common/Helper/Support/FormHelper";
import {mapState} from "vuex";
import {axiosGet} from "../../../../../common/Helper/AxiosHelper";

export default {
    name  : "HotelWorkPlaceCreateModal",
    mixins: [FormHelperMixins, ModalMixin],
    data() {
        return {
            TENANT_BASE_URL,
            locate       : 'ja',
            files        : [],
            fields       : [],
            current_files: [],
            deleted_files: [],
            pendingEditData: null,
            formData     : {
                title     : {},
                place     : {},
                station   : {},
                remark    : {},
                content   : {},
                salary    : {},
                deadline  : null,
                status    : null,
                permission: 0,
                require_shift: 1,
                tags      : [],
            },
        }
    },
    mounted() {
        axiosGet(`${TENANT_BASE_URL}api/attribute/fields/job`).then(({data}) => {
            this.fields = data
            if (this.fields.length > 0) {
                for (const field of this.fields) {
                    if (!this.formData[field.name] || typeof this.formData[field.name] !== 'object') {
                        this.$set(this.formData, field.name, {});
                    }
                }
            }

            if (this.pendingEditData) {
                this.applyEditData(this.pendingEditData);
            }
        })
    },
    computed: {
        ...mapState({
            languages: state => state.support.languages
        }),
        displayFields() {
            return this.fields.filter(field => !!this.getFieldLabel(field));
        },
        statusOptions() {
            return addSelectInSelectArray([
                {id: 'open', value: this.$t('job_open')},
                {id: 'close', value: this.$t('job_close')}
            ], 'value', 'status')
        }
    },
    methods : {
        getFieldLabel(field) {
            if (!field || !field.label) {
                return '';
            }

            return field.label[this.locate] || field.label.ja || field.label.en || '';
        },
        applyEditData(data) {
            this.formData = {
                title     : this.isEmptyArray(data.title),
                place     : this.isEmptyArray(data.place),
                station   : this.isEmptyArray(data.station),
                remark    : this.isEmptyArray(data.remark),
                content   : this.isEmptyArray(data.content),
                salary    : this.isEmptyArray(data.salary),
                deadline  : data.deadline,
                permission: data.permission || 0,
                status    : data.status,
                require_shift: data.require_shift ? 1 : 0,
                tags      : data.tags ? data.tags.map(tag => tag.id) : [],
            };

            if (this.fields.length > 0) {
                for (const field of this.fields) {
                    this.$set(this.formData, field.name, this.isEmptyArray(data[field.name]));
                }
            }
        },
        submitData() {
            let url      = this.$refs.form.dataset["url"];
            let formData = formDataAssigner(new FormData, this.formData);

            this.files.forEach(file => formData.append('thumbnail[]', file))
            this.deleted_files.forEach(fileUrl => formData.append('deleted_files[]', fileUrl))

            if (this.formData.title) {
                formData.set('title', JSON.stringify(this.formData.title))
            }
            if (this.formData.place) {
                formData.set('place', JSON.stringify(this.formData.place))
            }
            if (this.formData.station) {
                formData.set('station', JSON.stringify(this.formData.station))
            }
            if (this.formData.remark) {
                formData.set('remark', JSON.stringify(this.formData.remark))
            }
            if (this.formData.content) {
                formData.set('content', JSON.stringify(this.formData.content))
            }
            if (this.formData.salary) {
                formData.set('salary', JSON.stringify(this.formData.salary))
            }
            if (this.formData.tags) {
                this.formData.tags.forEach(tag_id => formData.append('tag_id[]', tag_id));
            }
            if (this.fields.length > 0) {
                for (const field of this.fields) {
                    formData.set(field.name, JSON.stringify(this.formData[field.name]))
                }
            }

            if (this.selectedUrl) {
                // for file update need to send by post.
                formData.append('_method', 'PATCH');
            }

            this.loading = true;
            this.submitFromFixin('post', url, formData);
        },
        afterSuccess({data}) {
            this.formData = {};
            $('#work-place-modal').modal('hide');
            this.$emit('input', false);
            this.toastAndReload(data.message, 'work-place-table');
        },
        afterSuccessFromGetEditData(response) {
            this.preloader     = false;
            this.current_files = response.data.thumbnail || [];
            delete response.data.thumbnail;
            this.pendingEditData = response.data;
            this.applyEditData(response.data);
        },
        getTranslate(row, key) {
            const locate = window?.appLanguage.toLowerCase()

            if (!row[key]) {
                return ''
            }

            if (row[key][locate] && row[key][locate] !== '') {
                return row[key][locate]
            }

            return row[key]['ja'] || ''
        },
        isEmptyArray(val) {
            if (!val) {
                return {}
            }
            return Array.isArray(val) && val.length === 0 ? {} : val;
        }
    },
}
</script>
